/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from "react";
import { AuthPayload } from "shared/models/models";

interface IUserContext {
  user: AuthPayload;
  set: () => void;
}
export const UserContext = createContext<IUserContext>({
  user: {
    sub: 0,
    email: "",
    lang: "en",
    ability: null,
    opr: false,
    own: false,
    adm: false,
    inv: false,
    space: 0,
  },
  set: () => {},
});

export const useUser = () => useContext(UserContext);
